import { invoiceFieldValidator } from '../../utils/validation.utils';
import _ from 'lodash';

export function getFieldValue(name, orders, activePersonNo) {
  if (orders.length > 0) {
    const order = orders[activePersonNo];
    const type = order['invoice'];
    if (type) {
      const val = type[_.camelCase(name)];
      if (val) {
        return val;
      }
    }
  }
  return '';
}

export function isValid(type, value, countryCode = null, data = null, company = true) {
  let generalValidity = !invoiceFieldValidator(value, type, countryCode, type == 'Telephone1' ? data : '', company);
  return generalValidity;
}

export function unpush(list, target) {
  return list.splice(list.indexOf(target), 1);
}

export function glnSuccess() {}

export function isGovernment(orgno, countryCode = null) {
  let compareTo = orgno.substring(0, 1);
  if (!countryCode || countryCode == 'SE' || countryCode == 'SWE') {
    return compareTo == '2';
  } else {
    return compareTo == '2';
  }
}

export function convertAutocomplete(value) {
  try {
    switch (value.toLowerCase()) {
      case 'name':
        return 'billing organization';
      case 'address1':
      case 'address2':
        return 'billing address-line1';
      case 'zip':
        return 'billing postal-code';
      default:
        return 'off';
    }
  } catch (error) {
    console.error(error);
    return "off";
  }
}
